import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useModelInfo } from '../../../common/ModelInfoContext';
import { find } from 'lodash';
import { translate } from '../../../utils/translate/translations';
import { PACKAGES_AND_OPTIONS } from '../../../common/steps';

const ChangeOption = ({ stepKey, isPreOrderCompleted }) => {
  const { steps } = useModelInfo();
  const { label, path } = find(steps, { key: stepKey });
  const relativePath = `../${path.charAt(0) === '/' ? path.substr(1) : path}`;
  const changeLabel = translate('change.v3') || 'change';
  return (
    <div className="math-box__change-option">
      <div className="math-box__change-option-label">{label}</div>
      {!isPreOrderCompleted && (
        <Link
          className="math-box__change-option-link stat-text-link"
          to={relativePath}
          data-dtm={`summary:${
            stepKey == PACKAGES_AND_OPTIONS ? 'options' : stepKey
          }`}>
          {changeLabel}
        </Link>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { reservation } = state;
  const { isPreOrderCompleted } = reservation;
  return { isPreOrderCompleted };
};

export default connect(mapStateToProps)(ChangeOption);
